import { CommonKeys } from "../../common/enums";
import { FORMULAR_GROUP_ZEITERFASSUNG_TYPE, ZEITERFASSUNG_TYPE, ZEITERFASSUNGEN_TYPE } from "../../common/formular-group-types";

const FormularGroupZeiterfassungSchema = {
    $id: "FormularGroupZeiterfassungSchema",
    title: "FormularGroupZeiterfassung Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_ZEITERFASSUNG_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        [CommonKeys.ShowLabel]: { type: "boolean", nullable: true },
        Zeiterfassungen: { $ref: "FormularGroupZeiterfassungZeiterfassungenSchema" }
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, "Zeiterfassungen"]
}

const FormularGroupZeiterfassungZeiterfassungenSchema = {
    $id: "FormularGroupZeiterfassungZeiterfassungenSchema",
    title: "FormularGroupZeiterfassungZeiterfassungen Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: ZEITERFASSUNGEN_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "FormularGroupZeiterfassungZeiterfassungSchema" }
        }
    },
    required: [CommonKeys.Type, CommonKeys.Values]
}

// TOOD: uncomment the fields when they're ready on the backend side
const ZEITERFASSUNG_PROPERTIES = {
    [CommonKeys.Type]: { const: ZEITERFASSUNG_TYPE },
    Name: { type: "string" },
    RessourcenID: { type: "string", format: "uuid" },
    ArbeitszeitBeginn: { type: "string", format: "date-time" },
    ArbeitszeitEnde: { type: "string", format: "date-time" },
    Zuschlag: { type: "number" },
    Zone: { type: "number" },
    Arbeitszeit: { type: "string", format: "time" },
    Fahrtzeit: { type: "string", format: "time" },
    Gesamtzeit: { type: "string", format: "time" }
}

const FormularGroupZeiterfassungZeiterfassungSchema = {
    $id: "FormularGroupZeiterfassungZeiterfassungSchema",
    title: "FormularGroupZeiterfassungZeiterfassung Schema",
    type: "object",
    properties: ZEITERFASSUNG_PROPERTIES,
    required: Object.keys(ZEITERFASSUNG_PROPERTIES)
}

export const FORMULAR_GROUP_ZEITERFASSUNG_SCHEMAS = [
    FormularGroupZeiterfassungSchema,
    FormularGroupZeiterfassungZeiterfassungenSchema,
    FormularGroupZeiterfassungZeiterfassungSchema
]